<template>
  <div v-loading="loading">
    <WfCaseShell
      :show-save="!readonly"
      :show-submit="!readonly"
      :show-back="false"
      :show-attach="!isRoutine && !isSelfSend"
      :next-node-label="readonly ? '' : submitTargetLabel"
      :saving="false"
      :submitting="submitting"
      @save="saveDraft"
      @submit="submit"
      @attach="noopAttach"
    >
      <template slot="next-node">
        <select
          v-if="!readonly"
          class="form-control input-sm"
          style="min-width: 120px; display: inline-block; width: auto; height: 34px; margin-left: 2px;"
          v-model="form.assignee_id"
          @change="onAssigneeChange(form.assignee_id)"
        >
          <option :value="null">请选择</option>
          <option v-for="u in dispatchers" :key="u.id" :value="dispatcherId(u)">{{ u.xm }}</option>
        </select>
      </template>
      <template slot="extra-actions">
        <button v-if="!isRoutine && !isSelfSend" type="button" class="btn btn-info hidden-xs" style="margin-left: 4px;" @click="noopAgreement">
          <i class="fa fa-file-text-o" /> 委托受理协议
        </button>
        <button v-if="!isRoutine && !isSelfSend" type="button" class="btn btn-info hidden-xs" style="margin-left: 4px;" @click="noopExportQuote">
          <i class="fa fa-download" /> 导出报价单
        </button>
        <button v-if="isRoutine" type="button" class="btn btn-info hidden-xs" style="margin-left: 4px;" @click="noopAgreement">
          受理委托协议
        </button>
        <button v-if="!readonly" type="button" class="btn btn-info hidden-xs" style="margin-left: 4px;" @click="loadLast">
          <i class="fa fa-history" /> 最近一次委托
        </button>
        <button v-if="showAuditBtn" type="button" class="btn btn-warning hidden-xs" style="margin-left: 4px;" @click="goAudit">委托审核</button>
        <button v-if="showPlanBtn" type="button" class="btn btn-success hidden-xs" style="margin-left: 4px;" @click="goPlan">周期任务安排</button>
      </template>

      <div v-if="routineSubmittedHint" class="alert alert-success" style="margin-bottom:12px">{{ routineSubmittedHint }}</div>

      <div class="lims-page-title"><div>企业委托表</div></div>

      <div class="panel panel-default">
        <div class="panel-heading"><span>委托单位信息</span></div>
        <div class="panel-body">
          <div class="form-horizontal">
            <div class="form-group">
              <label class="col-md-2 control-label text-require">委托单位</label>
              <div class="col-md-10">
                <div class="input-group input-group-sm">
                  <input type="text" class="form-control" :value="entrustEnt.ent_name" disabled placeholder="请选择..." />
                  <span class="input-group-btn">
                    <button class="btn btn-info" type="button" :disabled="readonly" @click="pickEnt('entrust')" title="点此选择企业信息">...</button>
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-2 control-label">联系地址:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" :value="entrustEnt.address" disabled /></div>
              <label class="col-md-2 control-label">联系人:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" :value="entrustEnt.linkman" disabled /></div>
            </div>
            <div class="form-group">
              <label class="col-md-2 control-label">行业:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" :value="entrustEnt.industry" disabled /></div>
              <label class="col-md-2 control-label">传真:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" :value="entrustEnt.fax" disabled /></div>
            </div>
            <div class="form-group">
              <label class="col-md-2 control-label">联系电话:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" :value="entrustEnt.phone" disabled /></div>
              <label class="col-md-2 control-label">邮箱:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" :value="entrustEnt.email" disabled /></div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading">
          <span>受检单位信息</span>
          <button class="btn btn-default btn-sm pull-right" type="button" style="margin-top:-5px" :disabled="readonly" @click="copySameEnt">
            <i class="fa fa-arrow-down" /> 受测与委托单位信息相同
          </button>
        </div>
        <div class="panel-body">
          <div class="form-horizontal">
            <div class="form-group">
              <label class="col-md-2 control-label text-require">受测单位:</label>
              <div class="col-md-10">
                <div class="input-group input-group-sm">
                  <input type="text" class="form-control" :value="targetEnt.ent_name" disabled placeholder="请选择..." />
                  <span class="input-group-btn">
                    <button class="btn btn-info" type="button" :disabled="readonly" @click="pickEnt('target')">...</button>
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-2 control-label">联系地址:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" :value="targetEnt.address" disabled /></div>
              <label class="col-md-2 control-label">联系人:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" :value="targetEnt.linkman" disabled /></div>
            </div>
            <div class="form-group">
              <label class="col-md-2 control-label">行业:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" :value="targetEnt.industry" disabled /></div>
              <label class="col-md-2 control-label">传真:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" :value="targetEnt.fax" disabled /></div>
            </div>
            <div class="form-group">
              <label class="col-md-2 control-label">联系电话:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" :value="targetEnt.phone" disabled /></div>
              <label class="col-md-2 control-label">邮箱:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" :value="targetEnt.email" disabled /></div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading"><span>委托单基本信息</span></div>
        <div class="panel-body">
          <div class="form-horizontal">
            <div class="form-group">
              <label class="col-md-2 control-label text-require">任务名称:</label>
              <div class="col-md-4"><input type="text" class="form-control input-sm" v-model="form.xmmc" :disabled="readonly" /></div>
              <label class="col-md-2 control-label">监测类型:</label>
              <div class="col-md-4">
                <select class="form-control input-sm" v-model="form.jclx" :disabled="readonly">
                  <option v-for="t in monitorTypes" :key="t" :value="t">{{ t }}</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-2 control-label">样品来源:</label>
              <div class="col-md-4">
                <select class="form-control input-sm" v-model="form.sample_source" :disabled="readonly || isSelfSend">
                  <option v-for="s in sampleSources" :key="s" :value="s">{{ s }}</option>
                </select>
              </div>
              <label class="col-md-2 control-label">委托日期:</label>
              <div class="col-md-4">
                <input type="date" class="form-control input-sm" v-model="form.entrust_date" :disabled="readonly" />
              </div>
            </div>
            <div class="form-group" v-if="isRoutine">
              <label class="col-md-2 control-label text-require">方案日期:</label>
              <div class="col-md-4">
                <input type="date" class="form-control input-sm" v-model="form.scheme_date" :disabled="readonly" @change="onSchemeDateChange(form.scheme_date)" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-2 control-label">加盖CMA资质章:</label>
              <div class="col-md-4 form-inline" style="padding-top:5px">
                <label class="radio-inline"><input type="radio" :value="true" v-model="form.need_cma" :disabled="readonly" /> 是</label>
                <label class="radio-inline"><input type="radio" :value="false" v-model="form.need_cma" :disabled="readonly" /> 否</label>
              </div>
              <label class="col-md-2 control-label">报告份数:</label>
              <div class="col-md-4">
                <select class="form-control input-sm" v-model.number="form.report_copies" :disabled="readonly">
                  <option :value="1">一份</option>
                  <option :value="2">两份</option>
                  <option :value="3">三份</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading">
          <span>监测详细信息</span>
        </div>
        <div class="panel-body" style="padding:0">
          <table class="table table-bordered table-condensed" style="margin:0">
            <thead>
              <tr>
                <th>项目类型</th>
                <th v-if="!isRoutine">项目子类型</th>
                <th>监测点位</th>
                <th>点位个数</th>
                <th>监测项目</th>
                <th>监测频次</th>
                <th v-if="isRoutine">12月</th>
                <th>方法依据</th>
                <th>备注</th>
                <th style="width:90px">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, $index) in items" :key="$index">
                <td>{{ row.basic_type }}</td>
                <td v-if="!isRoutine">{{ row.sub_type || '—' }}</td>
                <td>{{ fmtMonitorPlace(row) }}</td>
                <td class="text-center">{{ row.place_count }}</td>
                <td>{{ fmtItemNames(row) || '—' }}</td>
                <td class="text-center">{{ freqLabel(row) }}</td>
                <td v-if="isRoutine">{{ scheduleSummary(row) }}</td>
                <td>{{ methodLabel(row) }}</td>
                <td>{{ row.remark }}</td>
                <td>
                  <a href="javascript:;" @click.prevent="editItem(row, $index)">编辑</a>
                  <a href="javascript:;" style="margin-left:6px" @click.prevent="removeItem($index)">删除</a>
                </td>
              </tr>
              <tr v-if="!items.length"><td :colspan="isRoutine ? 9 : 9" class="text-center text-muted">暂无监测条目</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </WfCaseShell>

    <EnterprisePicker
      v-model="showEntPicker"
      :site-import-enabled="entPickTarget === 'entrust'"
      :scheme-year="form.routine_year"
      :scheme-date="form.scheme_date"
      :type-config="typeConfig"
      :freq-presets="freqPresetConfig.presets || freqPresetConfig"
      :type-infer-config="typeInferConfig"
      :is-routine="isRoutine"
      @select="onEntSelected"
      @pick-site="onSitePicked"
      @import-items="onSitesImported"
    />
    <MonitorItemDialog
      v-model="showItemDlg"
      :row="editRow"
      :type-config="typeConfig"
      :flow-model="flowModel"
      :ent-id="form.ent_id || entrustEnt.id"
      :freq-preset-config="freqPresetConfig"
      :type-infer-config="typeInferConfig"
      :site-options="entSites"
      @save="onItemSaved"
    />
  </div>
</template>

<script>
import api from '@/utils/api'
import EnterprisePicker from '@/components/EnterprisePicker.vue'
import MonitorItemDialog from '@/components/MonitorItemDialog.vue'
import WfCaseShell from '@/components/ivan/WfCaseShell.vue'
import { mapSiteToMonitorFields, displayItemNames, displayMonitorPlace, normalizeMonitorItemRow } from '@/utils/siteMonitorMap'
import { ensureDefaultSubType } from '@/utils/routineTypeInfer'
import { canEditRoutinePlan } from '@/utils/user'
import { todayDateStr, deriveSchemeDate, yearFromDateStr } from '@/utils/schemeDate'

function emptyEnt() {
  return { id: null, ent_name: '', address: '', linkman: '', phone: '', industry: '', fax: '', email: '' }
}

export default {
  name: 'EntrustFlow',
  components: { EnterprisePicker, MonitorItemDialog, WfCaseShell },
  props: {
    flowModel: { type: String, default: 'SimplifyMonitorEntrust' }
  },
  data() {
    return {
      loading: false,
      submitting: false,
      form: {
        id: null,
        xmbh: '',
        xmmc: '',
        jclx: '委托检测',
        sample_source: '委托采样检测',
        entrust_date: new Date().toISOString().slice(0, 10),
        need_cma: true,
        report_copies: 1,
        ent_id: null,
        target_ent_id: null,
        assignee_id: null,
        assignee_xm: '',
        audit_user_id: null,
        audit_user_xm: '',
        routine_year: new Date().getFullYear(),
        scheme_date: todayDateStr(),
        flow_model: 'SimplifyMonitorEntrust',
        xmzt: 'new',
        entrust_status: 'draft'
      },
      entrustEnt: emptyEnt(),
      targetEnt: emptyEnt(),
      items: [],
      dispatchers: [],
      auditors: [],
      freqPresetConfig: {},
      typeInferConfig: {},
      entSites: [],
      typeConfig: {},
      monitorTypes: ['委托检测', '自行监测', '监督检测', '企业自测'],
      sampleSources: ['委托采样检测', '客户送样检测'],
      showEntPicker: false,
      entPickTarget: 'entrust',
      showItemDlg: false,
      editRow: null,
      editIndex: -1,
      readonly: false
    }
  },
  computed: {
    isRoutine() {
      return this.flowModel === 'RoutineEntrustFlow'
    },
    isSelfSend() {
      return this.flowModel === 'SelfSendEntrustFlow'
    },
    submitTargetLabel() {
      if (this.isSelfSend) return '合同生成'
      // 对齐 8072 ToolBar 下一节点文案
      return this.isRoutine ? '委托审核' : '采样任务管理'
    },
    pageTitle() {
      if (this.isSelfSend) {
        if (this.form.id && this.form.entrust_status === 'submitted') return `来样检测业务流程（${this.form.xmbh}）`
        return '来样检测业务流程(新建)'
      }
      if (this.isRoutine) {
        if (this.form.id && this.form.entrust_status !== 'draft') return `周期任务执行（${this.form.xmbh}）`
        return '周期任务执行(新建)'
      }
      if (this.form.id && this.form.entrust_status === 'submitted') return `委托发起流程（${this.form.xmbh}）`
      return '委托发起流程(新建)'
    },
    showAuditBtn() {
      return this.isRoutine && this.form.xmzt === 'pending_audit'
    },
    showPlanBtn() {
      if (!this.isRoutine || !['audit_pass', 'plan_ready'].includes(this.form.xmzt)) return false
      return canEditRoutinePlan(this.form)
    },
    routineSubmittedHint() {
      // 仅「已提交且当前用户不是安排接收人」时提示；新建/草稿绝不显示
      if (!this.isRoutine) return ''
      if (this.form.entrust_status !== 'submitted') return ''
      if (!this.form.id && !this.form.xmbh) return ''
      if (canEditRoutinePlan(this.form)) return ''
      const who = (this.form.assignee_xm || '接收人').trim()
      return who ? `已提交至 ${who}，请等待周期任务安排` : ''
    },
    basePath() {
      if (this.isSelfSend) return '/self-send'
      return this.isRoutine ? '/routine' : '/entrust'
    },
    xmbhRoute() {
      return this.$route.params.xmbh || ''
    },
  },
  watch: {
    xmbhRoute: {
      immediate: true,
      handler(v) {
        if (v && v !== 'new') this.load(v)
      }
    },
    '$route'(to, from) {
      // 同组件内从详情切到新建时 activated 可能不触发
      if (!from || !this.isNewRoute(to) || this.isNewRoute(from)) return
      this.initNew()
    }
  },
  mounted() {
    // keep-alive 首次也会走 activated；此处只处理非新建，避免与 activated 重复拉 meta
    if (!this.isNewRoute(this.$route) && this.xmbhRoute && this.xmbhRoute !== 'new') {
      this.load(this.xmbhRoute)
    }
  },
  activated() {
    if (this.isNewRoute(this.$route)) {
      this.initNew()
    }
  },
  methods: {
    isNewRoute(route) {
      const r = route || this.$route
      const pathNew = this.isSelfSend ? '/self-send/new' : (this.isRoutine ? '/routine/new' : '/entrust/new')
      return r.path.endsWith(pathNew) || r.params.xmbh === 'new'
    },
    clearNewDraft() {
      this.entrustEnt = emptyEnt()
      this.targetEnt = emptyEnt()
      this.items = []
      this.entSites = []
      this.readonly = false
      this.form = {
        id: null,
        xmbh: '',
        xmmc: '',
        jclx: this.isRoutine ? '企业自测' : '委托检测',
        sample_source: this.isSelfSend ? '客户送样检测' : '委托采样检测',
        entrust_date: todayDateStr(),
        need_cma: true,
        report_copies: 1,
        ent_id: null,
        target_ent_id: null,
        assignee_id: null,
        assignee_xm: '',
        audit_user_id: null,
        audit_user_xm: '',
        routine_year: new Date().getFullYear(),
        scheme_date: todayDateStr(),
        flow_model: this.isRoutine
          ? 'RoutineEntrustFlow'
          : (this.isSelfSend ? 'SelfSendEntrustFlow' : 'SimplifyMonitorEntrust'),
        xmzt: 'new',
        entrust_status: 'draft'
      }
    },
    onSchemeDateChange(v) {
      if (!this.isRoutine) return
      const d = String(v || this.form.scheme_date || '').slice(0, 10)
      if (d) this.form.routine_year = yearFromDateStr(d)
      if (this.entrustEnt.id) {
        this.loadEntSites(this.entrustEnt.id)
        if (this.items.length) {
          this.$message.info(`方案日期已改为 ${d}，监测条目仍为当前表内容，可重新选企业按新方案带入`)
        }
      }
    },
    fmtItemNames(row) {
      return displayItemNames(row)
    },
    fmtMonitorPlace(row) {
      return displayMonitorPlace(row)
    },
    freqLabel(row) {
      if (row.freq_unit === 'period' || this.isRoutine) {
        const fl = (row.freq_label || '').trim()
        if (fl) return fl
        const fc = row.freq_count || row.freq_per_day || 1
        const pc = row.periods_count || 1
        return `${fc}次/期，共${pc}期`
      }
      return `${row.freq_per_day || 1}次/天`
    },
    scheduleSummary(row) {
      const sch = row.schedule_json
      if (!sch) return '—'
      let obj = sch
      if (typeof sch === 'string') {
        try { obj = JSON.parse(sch) } catch (e) { return '—' }
      }
      const months = []
      for (let m = 1; m <= 12; m++) {
        if (obj[String(m)] || obj[m]) months.push(m)
      }
      return months.length ? months.join(',') + '月' : '—'
    },
    noopAgreement() {
      this.$message.info('委托受理协议（占位，后续对接合同模块）')
    },
    noopAttach() {
      this.$message.info('附件上传（占位）')
    },
    noopExportQuote() {
      this.$message.info('导出报价单（占位）')
    },
    goAudit() {
      if (this.form.xmbh) this.$router.push('/routine/audit/' + encodeURIComponent(this.form.xmbh))
    },
    goPlan() {
      if (this.form.xmbh) this.$router.push('/routine/plan/' + encodeURIComponent(this.form.xmbh))
    },
    safeReplace(path) {
      if (this.$route.path === path) return Promise.resolve()
      return this.$router.replace(path).catch(err => {
        const dup = err && (err.name === 'NavigationDuplicated' || /NavigationDuplicated/i.test(String(err.message || '')))
        if (!dup) return Promise.reject(err)
      })
    },
    resetRoutineSubmitState() {
      const entId = this.form.ent_id
      const targetId = this.form.target_ent_id
      const assigneeId = this.form.assignee_id
      const assigneeXm = this.form.assignee_xm
      const entrustEnt = { ...this.entrustEnt }
      const targetEnt = { ...this.targetEnt }
      const routineYear = this.form.routine_year
      const schemeDate = this.form.scheme_date
      this.form = {
        id: null,
        xmbh: '',
        xmmc: '',
        jclx: '企业自测',
        sample_source: '委托采样检测',
        entrust_date: todayDateStr(),
        need_cma: true,
        report_copies: 1,
        ent_id: entId,
        target_ent_id: targetId,
        assignee_id: assigneeId,
        assignee_xm: assigneeXm,
        audit_user_id: null,
        audit_user_xm: '',
        routine_year: routineYear,
        scheme_date: schemeDate,
        flow_model: 'RoutineEntrustFlow',
        xmzt: 'new',
        entrust_status: 'draft'
      }
      this.entrustEnt = entrustEnt
      this.targetEnt = targetEnt
      this.items = []
      this.readonly = false
    },
    methodLabel(row) {
      const m = row.method_accord_json
      if (!m) return '—'
      if (typeof m === 'string' && !m.startsWith('[')) return m || '—'
      try {
        const a = JSON.parse(m)
        return Array.isArray(a) ? a.join('；') : String(m)
      } catch (e) { return String(m) }
    },
    async initNew() {
      this.loading = true
      try {
        const q = this.$route.query || {}
        // keep-alive 残留：无 query 指定企业时一律空白新建
        if (!q.ent_id) {
          this.clearNewDraft()
        }
        const action = this.isRoutine ? 'yn_routine_meta' : 'yn_entrust_meta'
        const res = await api.get(action)
        const d = res.data || {}
        this.typeConfig = d.monitor_types || {}
        this.monitorTypes = this.typeConfig.monitorTypes || this.monitorTypes
        this.sampleSources = this.typeConfig.sampleSources || this.sampleSources
        this.dispatchers = d.dispatchers || []
        this.auditors = d.auditors || []
        this.freqPresetConfig = d.freq_presets || {}
        this.typeInferConfig = d.type_infer || {}
        this.fillMissingSubTypes()
        if (this.isRoutine) {
          this.form.jclx = '企业自测'
          this.form.flow_model = 'RoutineEntrustFlow'
          this.form.entrust_status = 'draft'
          this.form.xmzt = 'new'
          this.form.id = null
          this.form.xmbh = ''
          const today = todayDateStr()
          this.form.scheme_date = today
          this.form.entrust_date = today
          this.form.routine_year = yearFromDateStr(today)
        }
        if (this.isSelfSend) {
          this.form.sample_source = '客户送样检测'
          this.form.flow_model = 'SelfSendEntrustFlow'
          this.form.jclx = '委托检测'
          this.form.entrust_status = 'draft'
          this.form.xmzt = 'new'
          this.form.id = null
          this.form.xmbh = ''
        }
        if (!this.isRoutine && !this.isSelfSend) {
          this.form.entrust_status = 'draft'
          this.form.xmzt = 'new'
          this.form.id = null
          this.form.xmbh = ''
        }
        const def = d.default_assignee
        if (def && def.id) {
          this.form.assignee_id = parseInt(def.id, 10)
          this.form.assignee_xm = def.xm
        } else if (this.dispatchers.length) {
          this.form.assignee_id = this.dispatcherId(this.dispatchers[0])
          this.form.assignee_xm = this.dispatchers[0].xm
        }
        if (q.ent_id) {
          this.clearNewDraft()
          this.form.ent_id = parseInt(q.ent_id, 10)
          this.entrustEnt.ent_name = q.ent_name || ''
          this.entrustEnt.id = this.form.ent_id
          this.form.target_ent_id = this.form.ent_id
          this.targetEnt.ent_name = this.entrustEnt.ent_name
          this.targetEnt.id = this.form.ent_id
          if (q.ent_name) this.form.xmmc = q.ent_name
          if (q.year) {
            const y = parseInt(q.year, 10)
            this.form.routine_year = y
            this.form.scheme_date = deriveSchemeDate(y, this.form.entrust_date)
          }
          // 重新套用接收人默认（clearNewDraft 会清掉）
          if (def && def.id) {
            this.form.assignee_id = parseInt(def.id, 10)
            this.form.assignee_xm = def.xm
          } else if (this.dispatchers.length) {
            this.form.assignee_id = this.dispatcherId(this.dispatchers[0])
            this.form.assignee_xm = this.dispatchers[0].xm
          }
          this.loadEntSites(this.form.ent_id)
        }
      } finally { this.loading = false }
    },
    async load(xmbh) {
      this.loading = true
      try {
        const res = await api.get('yn_entrust_get', { xmbh })
        if (res.data && res.data.error) {
          this.$message.error(res.data.error)
          return
        }
        const d = res.data
        this.typeConfig = d.monitor_types || {}
        this.monitorTypes = this.typeConfig.monitorTypes || this.monitorTypes
        this.sampleSources = this.typeConfig.sampleSources || this.sampleSources
        this.dispatchers = d.dispatchers || []
        this.auditors = d.auditors || []
        this.freqPresetConfig = d.freq_presets || {}
        this.typeInferConfig = d.type_infer || {}
        const p = d.project || {}
        this.form = {
          id: p.id,
          xmbh: p.xmbh,
          xmmc: p.xmmc,
          jclx: p.jclx || (this.isRoutine ? '企业自测' : '委托检测'),
          sample_source: p.sample_source || '委托采样检测',
          entrust_date: p.entrust_date || todayDateStr(),
          need_cma: p.need_cma == 1 || p.need_cma === true,
          report_copies: parseInt(p.report_copies || 1),
          ent_id: p.ent_id,
          target_ent_id: p.target_ent_id,
          assignee_id: p.assignee_id ? parseInt(p.assignee_id, 10) : null,
          assignee_xm: p.assignee_xm || '',
          audit_user_id: p.audit_user_id ? parseInt(p.audit_user_id, 10) : null,
          audit_user_xm: p.audit_user_xm || '',
          routine_year: parseInt(p.routine_year || new Date().getFullYear(), 10),
          scheme_date: deriveSchemeDate(p.routine_year, p.entrust_date),
          flow_model: p.flow_model || this.flowModel,
          entrust_status: p.entrust_status,
          xmzt: p.xmzt || 'new'
        }
        this.readonly = this.isRoutine
          ? (p.entrust_status !== 'draft' && p.xmzt !== 'new')
          : (p.entrust_status === 'submitted')
        this.entrustEnt = this.mapEnt(d.entrust_ent)
        this.targetEnt = this.mapEnt(d.target_ent)
        this.items = (d.items || []).map((it, i) => {
          const row = normalizeMonitorItemRow({ ...it, sort_no: i + 1 })
          ensureDefaultSubType(row, this.typeConfig)
          return row
        })
        this.fillMissingSubTypes()
        if (p.ent_id) this.loadEntSites(p.ent_id)
      } finally { this.loading = false }
    },
    async loadEntSites(entId) {
      const res = await api.get('yn_ent_site_list', { ent_id: entId, scheme_year: this.form.routine_year })
      this.entSites = res.data || []
    },
    mapEnt(e) {
      if (!e) return emptyEnt()
      return {
        id: e.id,
        ent_name: e.ent_name || '',
        address: e.address || '',
        linkman: e.linkman || '',
        phone: e.phone || '',
        industry: e.industry || '',
        fax: e.fax || '',
        email: e.email || ''
      }
    },
    pickEnt(target) {
      if (this.readonly) return
      this.entPickTarget = target
      this.showEntPicker = true
    },
    onEntSelected(ent) {
      const block = {
        id: ent.id,
        ent_name: ent.ent_name,
        address: ent.address || '',
        linkman: ent.linkman || '',
        phone: ent.phone || '',
        industry: ent.industry || '',
        fax: ent.fax || '',
        email: ent.email || ''
      }
      if (this.entPickTarget === 'target') {
        this.targetEnt = block
        this.form.target_ent_id = ent.id
        // 对齐 Ivan：受测单位名 → 任务名称
        if (ent.ent_name) this.form.xmmc = ent.ent_name
      } else {
        this.entrustEnt = block
        this.form.ent_id = ent.id
        this.entSites = ent.sites || []
        if (!this.entSites.length && ent.id) this.loadEntSites(ent.id)
        // 默认受测单位与委托单位相同
        this.targetEnt = { ...block }
        this.form.target_ent_id = ent.id
        // 任务名称默认 = 委托单位名
        if (ent.ent_name) this.form.xmmc = ent.ent_name
      }
    },
    onSitesImported(rows) {
      if (this.entPickTarget !== 'entrust') return
      const list = (rows || []).map((it, i) => {
        const row = normalizeMonitorItemRow({ ...it, sort_no: i + 1 })
        ensureDefaultSubType(row, this.typeConfig)
        return row
      })
      this.items = list
      if (list.length) {
        this.$message.success(`已带入 ${list.length} 条监测信息`)
      } else if (!this.entSites.length) {
        this.$message.info('该企业暂无点位，监测表已清空')
      } else {
        this.$message.info('未勾选点位，监测表已清空')
      }
    },
    onSitePicked(site) {
      this.showEntPicker = false
      const mapped = mapSiteToMonitorFields(site)
      this.editRow = {
        site_id: site.id,
        monitor_place: mapped.monitor_place,
        basic_type: site.basic_type,
        sub_type: site.sub_type,
        type_code: site.type_code,
        item_names: mapped.item_names,
        item_ids: site.item_ids,
        freq_label: site.freq_label,
        freq_count: site.freq_count,
        periods_count: site.periods_count,
        schedule_json: site.schedule_json,
        freq_unit: 'period'
      }
      this.editIndex = -1
      this.showItemDlg = true
    },
    copySameEnt() {
      if (!this.entrustEnt.id) {
        this.$message.warning('请先选择委托单位')
        return
      }
      this.targetEnt = { ...this.entrustEnt }
      this.form.target_ent_id = this.entrustEnt.id
      if (this.entrustEnt.ent_name) this.form.xmmc = this.entrustEnt.ent_name
    },
    fillMissingSubTypes() {
      if (this.isRoutine || !this.items.length) return
      this.items.forEach((row, i) => {
        if (row.sub_type || !row.basic_type) return
        const next = { ...row }
        ensureDefaultSubType(next, this.typeConfig)
        if (next.sub_type) this.$set(this.items, i, next)
      })
    },
    dispatcherId(u) {
      return parseInt(u.id, 10)
    },
    onAssigneeChange(id) {
      const u = this.dispatchers.find(x => this.dispatcherId(x) === parseInt(id, 10))
      this.form.assignee_xm = u ? u.xm : ''
    },
    onAuditorChange(id) {
      const u = this.auditors.find(x => this.dispatcherId(x) === parseInt(id, 10))
      this.form.audit_user_xm = u ? u.xm : ''
    },
    addItem() {
      if (this.readonly) return
      this.editRow = null
      this.editIndex = -1
      this.showItemDlg = true
    },
    editItem(row, index) {
      if (this.readonly) return
      this.editRow = { ...row }
      this.editIndex = index
      this.showItemDlg = true
    },
    removeItem(index) {
      if (this.readonly) return
      this.items.splice(index, 1)
    },
    onItemSaved(row) {
      const normalized = normalizeMonitorItemRow(row)
      if (this.editIndex >= 0) {
        this.$set(this.items, this.editIndex, normalized)
      } else {
        this.items.push(normalized)
      }
    },
    buildPayload() {
      return {
        id: this.form.id,
        xmbh: this.form.xmbh,
        xmmc: this.form.xmmc,
        jclx: this.form.jclx,
        sample_source: this.isSelfSend ? '客户送样检测' : this.form.sample_source,
        entrust_date: this.form.entrust_date,
        need_cma: this.form.need_cma,
        report_copies: this.form.report_copies,
        ent_id: this.form.ent_id || this.entrustEnt.id,
        target_ent_id: this.form.target_ent_id || this.targetEnt.id,
        assignee_id: this.form.assignee_id,
        assignee_xm: this.form.assignee_xm,
        audit_user_id: this.form.audit_user_id,
        audit_user_xm: this.form.audit_user_xm,
        routine_year: this.form.routine_year,
        flow_model: this.isRoutine ? 'RoutineEntrustFlow' : 'SimplifyMonitorEntrust',
        wtdw_mc: this.entrustEnt.ent_name,
        wtdw_dz: this.entrustEnt.address,
        lxr: this.entrustEnt.linkman,
        lxdh: this.entrustEnt.phone,
        items: this.items.map((it, i) => ({ ...it, sort_no: i + 1 }))
      }
    },
    async saveDraft() {
      if (this.readonly) return
      const res = await api.postJson('yn_entrust_save', this.buildPayload())
      if (res.data && res.data.error) {
        this.$message.error(res.data.error)
        return
      }
      this.form.id = res.data.id
      this.form.xmbh = res.data.xmbh
      this.$message.success('已暂存')
      if (this.$route.params.xmbh === 'new' && res.data.xmbh) {
        await this.safeReplace(this.basePath + '/' + encodeURIComponent(res.data.xmbh))
      }
    },
    async submit() {
      if (this.readonly) {
        this.$message.info('已提交的委托不可重复提交')
        return
      }
      if (!this.form.xmmc) {
        this.$message.warning('请填写任务名称')
        return
      }
      if (!this.form.ent_id && !this.entrustEnt.ent_name) {
        this.$message.warning('请选择委托企业')
        return
      }
      if (!this.items.length) {
        this.$message.warning('请添加监测详细信息')
        return
      }
      if (!this.form.assignee_id) {
        this.$message.warning('请选择接收人')
        return
      }
      this.submitting = true
      try {
        const action = this.isRoutine ? 'yn_routine_submit' : 'yn_entrust_submit'
        const res = await api.postJson(action, this.buildPayload())
        if (res.data && res.data.error) {
          this.$message.error(res.data.error)
          return
        }
        if (this.isSelfSend) {
          this.$message.success('已提交。下一节点：合同生成（请在合同管理中办理）')
          await this.safeReplace('/contracts')
          return
        }
        const assignee = this.form.assignee_xm || '接收人'
        this.$message.success(this.isRoutine ? `已提交至${assignee}（周期任务安排）` : '已提交至采样任务管理')
        if (this.isRoutine && !canEditRoutinePlan({ assignee_id: this.form.assignee_id })) {
          const targetNew = this.basePath + '/new'
          if (this.$route.path === targetNew) {
            this.resetRoutineSubmitState()
          } else {
            await this.safeReplace(targetNew)
            this.resetRoutineSubmitState()
          }
          return
        }
        await this.safeReplace(this.basePath + '/' + encodeURIComponent(res.data.xmbh))
        await this.load(res.data.xmbh)
      } finally { this.submitting = false }
    },
    async loadLast() {
      if (this.readonly) return
      const params = this.isRoutine ? { flow_model: 'RoutineEntrustFlow' } : {}
      const res = await api.get('yn_entrust_last', params)
      if (res.data && res.data.error) {
        this.$message.warning(res.data.error)
        return
      }
      const d = res.data
      this.typeConfig = d.monitor_types || this.typeConfig
      this.dispatchers = d.dispatchers || this.dispatchers
      this.auditors = d.auditors || this.auditors
      const p = d.project || {}
      this.form = {
        id: null,
        xmbh: '',
        xmmc: p.xmmc,
        jclx: p.jclx || (this.isRoutine ? '企业自测' : '委托检测'),
        sample_source: p.sample_source || '委托采样检测',
        entrust_date: todayDateStr(),
        need_cma: p.need_cma == 1 || p.need_cma === true,
        report_copies: parseInt(p.report_copies || 1),
        ent_id: p.ent_id,
        target_ent_id: p.target_ent_id,
        assignee_id: p.assignee_id ? parseInt(p.assignee_id) : null,
        assignee_xm: p.assignee_xm || '',
        audit_user_id: p.audit_user_id ? parseInt(p.audit_user_id) : null,
        audit_user_xm: p.audit_user_xm || '',
        routine_year: parseInt(p.routine_year || new Date().getFullYear(), 10),
        scheme_date: deriveSchemeDate(p.routine_year, todayDateStr()),
        flow_model: this.isRoutine ? 'RoutineEntrustFlow' : 'SimplifyMonitorEntrust',
        entrust_status: 'draft',
        xmzt: 'new'
      }
      this.entrustEnt = this.mapEnt(d.entrust_ent)
      this.targetEnt = this.mapEnt(d.target_ent)
      this.items = (d.items || []).map((it, i) => {
        const copy = normalizeMonitorItemRow({ ...it, sort_no: i + 1 })
        delete copy.id
        ensureDefaultSubType(copy, this.typeConfig)
        return copy
      })
      this.$message.success('已载入最近一次委托')
    }
  }
}
</script>

<style scoped>
.panel { margin-bottom: 14px; }
.bg-info .btn { margin-right: 4px; }
</style>
